import React, { useEffect } from "react";

/** Contexts */
import { useGroupBy } from "../../../../../../../utils/Context/TaskGroupByContext";
import { TaskPageEnums } from "../../../../../../../utils/Enums/TaskPageEnums";

/** Common Components */
import DropdownSelect from "../../../../../../ui/dropdown/DropdownSelect";
import Iconify from "../../../../../../../layouts/components/iconify/iconify";
import { DropdownWrapper } from "../../../../../../ui/dropdownwrapper/DropdownWrapper";

/** CSS Files */
import "./GroupByDropdown.scss";

const allGroupByOptions = [
  { icon: "clarity:assign-user-line", label: "Assignee", value: "assigneeName" },
  { icon: "cil:calendar", label: "Planning", value: "planningName" },
  { icon: "ant-design:project-outlined", label: "Project", value: "projectName" },
  { icon: "iconoir:priority-up", label: "Priority", value: "priorityName" },
  { icon: "f7:status", label: "Status", value: "statusName" },
  { icon: "carbon:task-settings", label: "Type", value: "taskTypeName" },
];

const hiddenGroupByByPage = {
  [TaskPageEnums.ALL]: ["planningName"],
  [TaskPageEnums.MY_PROJECT_TASK]: ["planningName"],
};

const GroupByDropdown = ({ taskFilterPageId } = {}) => {

  const {
    selectedOption,
    selectedGroupBy,
    setSelectedOption,
    setSelectedGroupBy,
    handleDeleteClick,
  } = useGroupBy();

  const hiddenValues = hiddenGroupByByPage[taskFilterPageId] || [];
  const groupByOptions = allGroupByOptions.filter((option) => !hiddenValues.includes(option.value));

  useEffect(() => {
    if (selectedGroupBy?.value && hiddenValues.includes(selectedGroupBy.value)) {
      handleDeleteClick();
    }
    // hiddenValues is derived from taskFilterPageId
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleDeleteClick, selectedGroupBy, taskFilterPageId]);

  const handleOptionClick = (option) => {
    setSelectedOption(option.label);
    setSelectedGroupBy(option);
  };

  const handleGroupByChange = (value) => {
    setSelectedGroupBy(value);
    setSelectedOption(value?.label || "None");
  };

  return (
    <DropdownWrapper
      className={"group-by-dropdown"}
      toggleElement={
        <div
          className={`group-by-btn ${selectedOption !== "None" ? "active" : ""}`}
        >
          <button type="button">
            <Iconify icon="formkit:group" width={16} />
            <span>Group : {selectedOption}</span>
          </button>
        </div>
      }
    >
      {selectedOption === "None" ? (
        <div className="group-by-options">
          {groupByOptions.map((option) => (
            <button
              type="button"
              key={option.value}
              className={`group-by-options-item ${selectedGroupBy?.label === option.label ? 'selected' : ''}`}
              onClick={() => handleOptionClick(option)}
            >
              <Iconify icon={option.icon} width={18} />
              <div className="group-by-options-itemlabel">
                {option.label}
              </div>
            </button>
          ))}
        </div>
      ) : (
        <div className="selected-option-content">
          <div className="group-by-title">Group by</div>
          <div className="group-options">
            <div className="group-by-project">
              <DropdownSelect
                placeholder="Select Group By"
                value={selectedGroupBy || { label: "Select Group By", value: "" }}
                optionsValue={groupByOptions}
                handleDropdownChange={handleGroupByChange}
              />
            </div>
            <button type="button" className="delete-icon" onClick={handleDeleteClick} title="Clear group by">
              <Iconify icon="material-symbols:delete-outline" />
            </button>
          </div>
        </div>
      )}
    </DropdownWrapper>
  );
};


export default GroupByDropdown;
